
import { IGlobalState } from '../states/GlobalState';
import { GetConfiguration } from "../utils/config";
import Auth, { AuthDataType} from '../types/auth';
import { User } from 'oidc-client';
import { getHeadersForSSO, handleErrorsForSSO } from './identityService';
import { PrincipalSearchModel } from '../models/principal';
import { PrincipalAuth, PrincipalAuthSearchModel } from '../models/principalAuth';

export const getPrincipalAuths = (ip: string, authData: AuthDataType, user: User, model: PrincipalAuthSearchModel): Promise<PrincipalAuth[]> => {        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Get Principals Auths data', JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principalauth/search`
    console.log('Get PrincipalAuths', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`GetPrincipals ("${authData.user}") -> letti ${json.length} agencies`);
            console.log('GetPrincipals recuperato json: ' + JSON.stringify(json));
            const rv = (json as PrincipalAuth[]);
            console.log('GetPrincipals recuperate: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('GetPrincipals error:', error);
            throw error;
        });
}

export const getPrincipalAuth = (ip: string, authData: AuthDataType, user: User, id: number): Promise<PrincipalAuth> => {        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Get Principal Auth id: ' + id);
    const url = `${GetConfiguration().api_url}/principalauth/${id}`
    console.log('Get PrincipalAuths', url);
    return window.fetch(url, {
        method: 'GET',
        headers: getHeadersForSSO(ip, user)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`GetPrincipalAuth ("${authData.user}") -> letti ${json.length} pauth`);
            console.log('GetPrincipalauth recuperato json: ' + JSON.stringify(json));
            const rv = (json as PrincipalAuth);
            console.log('GetPrincipalAuth recuperata: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('GetPrincipalAuth error:', error);
            throw error;
        });
}

export const updatePrincipalAuth = (ip: string, authData: AuthDataType, user: User, model: PrincipalAuth): Promise<PrincipalAuth> => {
        
    // let body = EntityUtils.isEntity(model) ? EntityUtils.asJSON(model) : JSON.stringify(model);
    console.log('Insert/Update PrincipalAuth con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principalauth`
    console.log('Update PrincipalAuth', url);
    return window.fetch(url, {
        method: 'POST',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(model)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            console.log(`updatePrincipalAuth ("${authData.user}") -> letti ${json.length} pauth`);
            console.log('updatePrincipalAuth recuperata json: ' + JSON.stringify(json));
            const rv = (json as PrincipalAuth);
            console.log('updatePrincipalAuth recuperata principalauth: ' + JSON.stringify(rv));
            return rv;
        })
        .catch(error => {
            console.log('updatePrincipalAuth error:', error);
            throw error;
        });
}

export const deletePrincipalAuth = (ip: string, authData: AuthDataType, user: User, id: number): Promise<boolean> => {
        
    // console.log('Update Principal con oggetto: ', + JSON.stringify(model));
    const url = `${GetConfiguration().api_url}/principalauth`
    console.log('Delete Principalauth', url);
    return window.fetch(url, {
        method: 'DELETE',
        headers: getHeadersForSSO(ip, user),
        body: JSON.stringify(id)
    })
        .then(res => handleErrorsForSSO(res))
        .then(res => res.json())
        .then(json => {
            // console.log(`deletePrincipal ("${authData.user}") -> letti ${json.length} agency`);
            console.log('deletePrincipalauth avente id: ' + id);
            const rv = (json as boolean);
            return rv;
        })
        .catch(error => {
            console.log('deletePrincipalauth error:', error);
            throw error;
        });
}